import { useQuery } from '@tanstack/react-query';
import { Notice, RaroBrand } from '@raro/ui';
import { useParams } from 'react-router';
import { IngestGuide, type IngestGuideData } from '../components/IngestGuide';
import { api } from '../lib/api';

/**
 * Página pública com o passo a passo de uma entrega automática, para a TI do cliente. Não mostra dado nem o token:
 * quem tem o link lê como enviar, mas só envia com o token que recebeu da Raro.
 */
export function EntregaPage() {
  const { id = '' } = useParams();
  const q = useQuery({ queryKey: ['entrega', id], queryFn: () => api.get<IngestGuideData>(`/ingest/${id}/guide`), retry: false });
  return (
    <div className="rr-entrega">
      <header className="rr-entrega__head">
        <RaroBrand />
        <span className="rr-label">entrega de dados</span>
      </header>
      {q.isLoading && <p className="rr-faint">abrindo…</p>}
      {q.isError && <Notice tone="error">{(q.error as Error).message}</Notice>}
      {q.data && (
        <>
          <div className="rr-stack rr-stack--2">
            <h1 className="rr-entrega__title">como enviar "{q.data.name}" para a machine.raro</h1>
            <p className="rr-entrega__lead">a Raro acompanha este relatório pela machine.raro. o envio é feito pelo seu sistema, com um token que só serve para isso.</p>
          </div>
          <IngestGuide guide={q.data} />
          <p className="rr-faint" style={{ fontSize: 'var(--rr-text-xs)' }}>dúvidas: fale com quem lhe enviou este link na Raro.</p>
        </>
      )}
    </div>
  );
}
